<template>
  <nav class="navbar">
    <div class="navbar-logo">
      <img src="logo-roboto.png" alt="Logo" />
    </div>
    <button class="menu-toggle" @click="menuOpen = !menuOpen">
      <span class="menu-icon">&#9776;</span>
    </button>
    <ul :class="['navbar-menu', { 'open': menuOpen }]">
        <li><router-link to="/" @click="menuOpen = false">Home</router-link></li>
        <li><router-link to="/about" @click="menuOpen = false">About Us</router-link></li>
        <li><router-link to="/vision" @click="menuOpen = false">Our Vision</router-link></li>
        <li><router-link to="/programs" @click="menuOpen = false">Programs</router-link></li>
        <li><router-link to="/contact" @click="menuOpen = false">Contact</router-link></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'HeaderNav',
  props: {
    isEn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuOpen: false
    };
  }
};
</script>

<style scoped>
.navbar {
  background: #044072;
  padding: 0.5rem 1rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navbar-logo {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}
.navbar-logo img {
  height: 40px;
  width: auto;
}
.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #fff;
  cursor: pointer;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.navbar-menu {
  flex: 1;
  list-style: none;
  display: flex;
  gap: 1.5rem;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
}
.navbar-menu li {
  color: #fff;
}
.navbar-menu a {
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background 0.3s;
}
.navbar-menu a:hover {
  background: rgba(255, 255, 255, 0.2);
}
.navbar-menu.open {
  display: flex;
}
@media (max-width: 700px) {
  .menu-toggle {
    display: block;
  }
  .navbar-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 70%;
    height: 100vh;
    background: #044072;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    justify-content: center;
    padding: 2rem 0;
    box-shadow: -2px 0 12px rgba(0, 0, 0, 0.2);
    transition: right 0.3s ease-in-out;
  }
  .navbar-menu.open {
    right: 0;
  }
}
</style>
